import { useState, useEffect } from "react";
import { $host } from "../../../../http";
import SelectWebinarModal from "./ SelectWebinarModal";
import ReactPlayer from "react-player";

const EditThemeModal = ({ isOpen, onClose, themeData, onUpdate, onDelete }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [webinarRoomID, setWebinarRoomID] = useState(null);
    const [webinarData, setWebinarData] = useState(null);
    const [isWebinarModalOpen, setIsWebinarModalOpen] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (isOpen && themeData) {
            setTitle(themeData.title || "");
            setDescription(themeData.description || "");
            setWebinarRoomID(themeData.webinar_room_id || null);
        }
    }, [isOpen, themeData]);

    // 🔥 Грузим данные вебинара при открытии модалки
    useEffect(() => {
        if (isOpen && webinarRoomID) {
            fetchWebinarData();
        }
    }, [isOpen, webinarRoomID]);

    const fetchWebinarData = async () => {
        try {
            console.log("Отправляем запрос на получение вебинара:", webinarRoomID);
            const response = await $host.get(`/api/teachers/webinars-records/webinar/${webinarRoomID}`, {
                withCredentials: true,
            });

            if (response?.data?.room) {
                console.log("✅ Данные вебинара получены:", response.data.room);
                setWebinarData(response.data.room);
            }
        } catch (error) {
            console.error("❌ Ошибка загрузки вебинара:", error.response?.data?.message || error.message);
        }
    };

    const handleSelectWebinar = async (selectedWebinar) => {
        if (!selectedWebinar || !themeData?.id) return;

        try {
            console.log("Отправляем запрос на обновление темы с вебинаром:", selectedWebinar.id);
            await $host.put(`/api/teachers/themes/${themeData.id}`, {
                webinar_room_id: selectedWebinar.id,
            }, { withCredentials: true });

            setWebinarRoomID(selectedWebinar.id);
            fetchWebinarData(); // Загружаем свежие данные
            setIsWebinarModalOpen(false);
        } catch (error) {
            console.error("❌ Ошибка обновления темы:", error.response?.data?.message || error.message);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!themeData?.id) {
            console.error("❌ Ошибка: отсутствует ID темы");
            return;
        }

        try {
            console.log("Отправляем запрос на сохранение темы:", { title, description });
            await $host.put(`/api/teachers/themes/${themeData.id}`, {
                title,
                description,
            }, { withCredentials: true });

            onUpdate(themeData.id, { title, description });
            onClose();
        } catch (error) {
            console.error("❌ Ошибка обновления темы:", error.response?.data?.message || error.message);
        }

    };
    const handleDelete = async () => {
        if (!themeData?.id) return;
        try {
            await $host.delete(`/api/teachers/themes/${themeData.id}`, { withCredentials: true });

            if (onUpdate) onUpdate(themeData.id, null); // ⬅️ Проверяем, есть ли onUpdate, и только потом вызываем
            if (onDelete) onDelete(themeData.id); // ⬅️ Вызываем удаление на странице
            onClose(); // ⬅️ Закрываем модалку
        } catch (error) {
            console.error("Ошибка удаления темы:", error.response?.data?.message || error.message);
        }
    };




    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-[500px] relative">
                <h2 className="text-xl font-bold mb-4">Редактировать тему</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium">Название</label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="mt-1 p-2 w-full border rounded-md"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium">Описание</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="mt-1 p-2 w-full border rounded-md"
                        />
                    </div>

                    {/* Блок с вебинаром */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium">Вебинар</label>
                        <div className="relative border rounded-lg overflow-hidden shadow-md">
                            {webinarData?.video_preview ? (
                                <img
                                    src={webinarData.video_preview}
                                    alt="Превью вебинара"
                                    className="w-full h-32 object-cover"
                                />
                            ) : webinarData?.link_recording === "" ? (
                                <div className="w-full h-32 bg-gray-400 flex items-center justify-center text-white text-sm font-semibold">
                                    Запись отсутствует
                                </div>
                            ) : (
                                <div className="w-full h-32 bg-blue-500 flex items-center justify-center text-white text-sm font-semibold">
                                    Нет превью
                                </div>
                            )}
                            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2 flex justify-between items-center">
                                {webinarData?.created_at && (
                                    <span className="text-xs">
                                        {new Date(webinarData.created_at).toLocaleDateString()}
                                    </span>
                                )}
                                {webinarData?.link_recording && webinarData?.link_recording !== "" && (
                                    <button
                                        type="button"
                                        className="text-sm bg-blue-500 px-3 py-1 rounded"
                                        onClick={() => setIsPlaying(true)}
                                    >
                                        ▶️ Смотреть
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className="text-sm bg-gray-300 px-3 py-1 rounded"
                                    onClick={() => setIsWebinarModalOpen(true)}
                                >
                                    ✏️ Изменить
                                </button>
                            </div>
                        </div>
                    </div>


                    <div className="flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-300 rounded-md"
                        >
                            Отмена
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded-md"
                        >
                            Сохранить
                        </button>
                        <button
                            type="button"
                            onClick={handleDelete}
                            className="px-4 py-2 bg-red-500 text-white rounded-md"
                        >
                            Удалить тему
                        </button>
                    </div>
                </form>
            </div>

            {/* Модалка выбора вебинара */}
            <SelectWebinarModal
                isOpen={isWebinarModalOpen}
                onClose={() => setIsWebinarModalOpen(false)}
                onSelect={handleSelectWebinar}
                themeId={themeData?.id}
                onUpdate={onUpdate}
            />

            {/* Модалка для просмотра вебинара */}
            {isPlaying && webinarData?.link_recording && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-[600px]">
                        <h2 className="text-xl font-bold mb-4">Просмотр вебинара</h2>
                        <ReactPlayer
                            url={webinarData.link_recording}
                            controls
                            width="100%"
                            height="350px"
                            playing
                        />
                        <button
                            onClick={() => setIsPlaying(false)}
                            className="mt-4 px-4 py-2 bg-red-500 text-white rounded-md w-full"
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditThemeModal;
